import React from 'react'

interface Props {
  richText: string
}

function RichTextField(props: Props) {
  const { richText } = props
  return <div dangerouslySetInnerHTML={{ __html: richText }} />
}

export default RichTextField
